/** @jsxImportSource theme-ui */
import React from 'react';

import { FlexGroup } from 'components/_common/FlexGroup';
import { Typography } from 'components/_common/Typography';
import { TypographyColor } from 'components/_common/Typography/Typography';

type CaseCountRowProps = {
  label: string;
  stat: string;
  aoi?: boolean;
  boldLabel?: boolean;
};

export const CaseCountRow: React.FC<CaseCountRowProps> = ({
  label,
  stat,
  aoi = false,
  boldLabel = false,
}) => {
  const color: TypographyColor = aoi ? 'seafoam100' : 'stone90';
  return (
    <FlexGroup
      sx={{ '&:not(:last-child)': { mb: '10px' } }}
      suffix={
        <Typography variant="subtitle2" color={color}>
          {stat}
        </Typography>
      }
    >
      <Typography variant={boldLabel ? 'subtitle2' : 'body2'} color={color}>
        {label}
      </Typography>
    </FlexGroup>
  );
};
